export enum DataType
{
    FlexDate = 1,
    Date = 2,
    Boolean = 3,
    Number = 4,
    String = 5,
    Html = 6
}